export default __webpack_public_path__ + "static/yetta-0061686f5127a3f2c0dccee8b3234cd0.jpg";